module.exports = __webpack_public_path__ + "static/media/app.916eda2b.scss";


//////////////////
// WEBPACK FOOTER
// ./src/scss/app.scss
// module id = 195
// module chunks = 0